import React from 'react'

const AgsaMapping = () => {
  return (
    <div>AgsaMapping</div>
  )
}

export default AgsaMapping